/**
 * Sterilization log (assistant role test 2026-10-20, fix 7). Route
 * `/sterilization`: record a sterilizer cycle (date and time, sterilizer,
 * load, indicator pass or fail, spore test, operator, packs) and read the
 * office's log. Office-scoped; entries are voided with a reason, never deleted.
 */
import { defineManifest } from '@velora/contracts';
import {
  STERILIZATION_ENTITY,
  STERILIZATION_PERMISSIONS as P,
} from '@velora/contracts/sterilization';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'sterilization',
    title: 'Sterilization log',
    version: '0.1.0',
    owner: 'WP4-STERILIZATION',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'log',
        path: '/sterilization',
        title: 'Sterilization log',
        officeScope: 'location',
        permission: P.view,
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Sterilization log',
        group: 'clinical',
        routeId: 'log',
        icon: 'shield-check',
        order: 80,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'sterilization.log',
        title: 'Sterilization log',
        keywords: ['sterilization', 'autoclave', 'statim', 'spore test', 'load', 'cycle', 'osha'],
        routeId: 'log',
        permission: P.view,
      },
    ],
    sseEntityKeys: [STERILIZATION_ENTITY],
    phiReadPoints: [],
  }),
  pages: {
    log: () => import('./SterilizationPage.js'),
  },
});
